import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/app/services/common.service';
import {
  EntityType,
  ResponseMessageStatus,
  ResponseStatus,
  SortBy,
  StockLocation,
} from 'src/app/shared/enums';
import { BadeLoftService } from '../bade-loft.service';

import * as day from 'dayjs';
import { NzModalService } from 'ng-zorro-antd/modal';
import moment from 'moment';
import { DatePipe } from '@angular/common';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.css'],
})
export class StatusComponent implements OnInit {
  //#region properties
  lst_Status: any = [];
  stockLocation: typeof StockLocation;
  sortField: string = 'createddate';
  sortBy: number = SortBy.Dsc;
  page: number = 1;
  pageSize: number = 100;
  totalRecord: number = 0;
  searchText: string = '';
  oldSearchText: string = '';
  timer: any = null;
  isStatusLoaded: boolean = false;
  isAuditVisible: boolean = false;
  entityDetails: any;
  entityType: number = EntityType.Status;
  statusMaxPageSize: number = 0;
  checkedAccountData = false;
  indeterminateAccountData = false;
  setOfCheckedIdAccountData = new Set<number>();
  isShowChangeShipDate: boolean = false;
  shipDate: Date = new Date();
  bl_Status: string = '';
  statusList_Request: any;
  filterDate: any = [];
  popConfirmVisible: boolean = false;
  shippedCompleted = false;
  setOfCheckedId = new Set<number>();
  selected: { start: Date; end: Date };
  ranges: any = {
    Today: [day(), day()],
    Yesterday: [day().subtract(1, 'days'), day().subtract(1, 'days')],
    Tomorrow: [day().add(1, 'days'), day().add(1, 'days')],
    'Last 7 Days': [day().subtract(6, 'days'), day()],
    'Last 30 Days': [day().subtract(29, 'days'), day()],
    'This Month': [day().startOf('month'), day().endOf('month')],
    'Last Month': [
      day().subtract(1, 'month').startOf('month'),
      day().subtract(1, 'month').endOf('month'),
    ],
  };
  isAssignmentVisible: boolean = false;
  editAssignmentDetail: any = null;
  stockAssignmentDetail: any = null;
  currentStatus: any = 1;
  incompleteStatusCount: any = 0;
  incompleteStatusList_Request: any = null;
  //isRouteEnabled: boolean = false;
  //isVisibleRouteModal: boolean = false;
  currentCompletingId: any;
  currentInvoiceAmount: number = 0;
  userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');

  //#endregion

  //#region functions
  onQueryParamsChange(event: any) {
    this.pageSize = this.pageSize;
    this.page = event;
    if (this.currentStatus == 1) {
      this.getStatusList();
    } else {
      this.getIncompletedStatusList();
    }
    // this.getStatusList();
  }
  hideCompletionPopConfirm(id: any) {
    this.popConfirmVisible = false;
    this.setOfCheckedId.delete(id);
  }
  currentCheckBoxId: any = null;
  toggleShippingPopConfirm(event: any, id: any) {
    this.currentCheckBoxId = id;
    this.popConfirmVisible == true
      ? (this.popConfirmVisible = false)
      : (this.popConfirmVisible = true);
    if (event) {
      this.popConfirmVisible = true;
      this.setOfCheckedId.clear();
      this.setOfCheckedId.add(id);
    } else {
      this.setOfCheckedId.delete(id);
    }
  }

  handleCancelRoute() {
    //this.isVisibleRouteModal = false;
  }
  handleOkRoute(data?: any) {
    this.currentCompletingId = data.id;
    var index = this.lst_Status.findIndex(
      (obj: any) => obj.id == this.currentCompletingId
    );
    this._blS
      //.UpdateShippedStatus(this.currentCompletingId, this.isRouteEnabled)
      .UpdateShippedStatus(this.currentCompletingId)
      .subscribe(
        (response: any) => {
          if (response.responseStatus == ResponseStatus.Success) {
            this.lst_Status.splice(index, 1);
            this._cS.displayMessage(
              ResponseMessageStatus.success,
              response.message
            );
            //this.isVisibleRouteModal = false;
            this._cS.incompleteStatusCountObserver.next('call');
            // setTimeout(function(){
            //   window.open('https://badeloft.starship.online/Sources?SourceID=501&CompanyName=Badeloft%20USA&DocumentKeys='+response.result.invoiceNo+'&DocumentType=Invoices&ShipmentID=0&UrlActionEnum=CreateShipment&UrlAction=CreateShipment&IsOccupySeatAction=True&IsRateOnly=False');
            // },500);
          } else {
            this._cS.displayMessage(
              ResponseMessageStatus.error,
              response.message
            );
          }
        },
        (error: any) => {
          this._cS.displayMessage(ResponseMessageStatus.error, error.message);
        }
      );
  }
  // confirmShippingCompletion(data: any) {
  //  // this.isRouteEnabled = false;
  //   this.currentCompletingId = data.id;
  //   if (data.customerName.toLowerCase() == 'wayfair') {
  //     this.handleOkRoute();
  //   } else {
  //     this._blS
  //       .getInvoiceAmount(data.transactionID)
  //       .subscribe((response: any) => {
  //         if (response.responseStatus == ResponseStatus.Success) {
  //           this.currentInvoiceAmount = response.result;
  //           if (this.currentInvoiceAmount <= 5000) {
  //             //this.isVisibleRouteModal = true;
  //             this.handleOkRoute();
  //           } else {
  //             this.handleOkRoute();
  //           }
  //         } else {
  //           this.currentInvoiceAmount = 0;
  //         }
  //       });
  //   }
  // }

  onExpandChange(i: number, checked: boolean, data: object, id: any): void {
    this.isStatusLoaded = true;
    this.lst_Status[i].expand = checked;
    this._blS.GetAssignmentStock(id).subscribe((res) => {
      if (res) {
        if (res.responseStatus == ResponseStatus.Success) {
          this.lst_Status[i].stocks = res.result;
        } else {
          this._cS.displayMessage(ResponseMessageStatus.error, res.message);
        }
        this.isStatusLoaded = false;
      }
    });
    this.isExpandAll =
      this.lst_Status.findIndex((x: any) => x.expand == true) > -1
        ? false
        : true;

    // if (this.isExpandAll) {
    //   this.lst_Status.map(function (x: any) {
    //     if (x != data) {
    //       x.expand = false;
    //     }
    //   });
    // }
  }

  // onExpandChange(i: number, checked: boolean, data: object): void {
  //   this.lst_Status[i].expand = checked;
  //   this.lst_Status.map(function (x: any) {
  //     if (x != data) {
  //       x.expand = false;
  //     }
  //   });

  //   this.lst_Status.map(function (x: any) {
  //     if (x != data) {
  //       x.expand = false;
  //     }
  //   });
  // }

  getStatusList() {
    if (!this.filterDate) {
      this.selected = {
        start: this.ranges['Today'][0],
        end: this.ranges['Today'][1],
      };
      this.filterDate[0] = moment()
        .set({ hour: 5, minute: 30, second: 0 })
        .utc()
        .format();
      this.filterDate[1] = moment()
        .set({ hour: 5, minute: 29, second: 59 })
        .utc()
        .format();
    }
    try {
      this.isStatusLoaded = true;
      this.statusList_Request = this._blS
        .GetStatusV1(
          this.searchText.trim(),
          this.sortField,
          this.sortBy,
          this.page,
          this.pageSize,
          this.filterDate[0],
          this.filterDate[1],
          false
        )
        .subscribe((res) => {
          if (res) {
            if (res.responseStatus == ResponseStatus.Success) {
              // this.lst_Status = [];
              // var data = res.result.assignments;
              // this.lst_Status = data;
              // this.totalRecord = res.result.totalRecord;
              var data = res.result.records;
              this.totalRecord = res.result.totalRecord;
              this.statusMaxPageSize = res.result.totalPage;
              if (data && data.length > 0) {
                data.forEach((x: any) => {
                  this.lst_Status.push(x);
                  x.isResyncing = false;
                });
              }
              this.lst_Status.map((x: any) => {
                x.expand = false;
              });
            } else {
              this._cS.displayMessage(ResponseMessageStatus.error, res.message);
            }
            var local_data = {
              searchText: this.searchText,
              sortBy: this.sortBy,
              sortField: this.sortField,
            };
            this._cS.setLocalStorageItem(
              'status_data',
              JSON.stringify(local_data)
            );
          }
          this.isStatusLoaded = false;
        });
    } catch (error) {}
  }

  resyncInvoice(data: any) {
    data.isResyncing = true;
    try {
      var requestBody = {
        eventNotifications: [
          {
            realmId: environment.realmId,
            dataChangeEvent: {
              entities: [
                {
                  realmId: environment.realmId,
                  name: 'Invoice',
                  id: data.transactionID,
                  operation: 'Update',
                  lastUpdated: '2024-08-21T10:12:40.064Z',
                  userId: 0,
                },
              ],
            },
          },
        ],
      };
      this._blS.QBOWebhookCallBack(requestBody).subscribe((res) => {
        data.isResyncing = false;
        this._cS.displayMessage(
          ResponseMessageStatus.success,
          'Invoice resync request sent successfully!'
        );
        this.loadStatusData();
      });
    } catch (err) {
      data.isResyncing = false;
    }
  }

  getIncompletedStatusList() {
    try {
      this.isStatusLoaded = true;
      this.incompleteStatusList_Request = this._blS
        .getIncompletedStatus(
          this.searchText.trim(),
          this.sortField,
          this.sortBy,
          this.page,
          this.pageSize,
          this.filterDate[0],
          this.filterDate[1],
          false
        )
        .subscribe((res) => {
          if (res) {
            if (res.responseStatus == ResponseStatus.Success) {
              this.lst_Status = [];
              // var data = res.result.assignments;
              // this.lst_Status = data;
              // this.totalRecord = res.result.totalRecord;
              var data = res.result.records;
              this.totalRecord = res.result.totalRecord;
              this.statusMaxPageSize = res.result.totalPage;
              if (data && data.length > 0) {
                data.forEach((x: any) => {
                  this.lst_Status.push(x);
                });
              }
              this.lst_Status.map((x: any) => {
                x.expand = false;
              });
            } else {
              this._cS.displayMessage(ResponseMessageStatus.error, res.message);
            }
            var local_data = {
              searchText: this.searchText,
              sortBy: this.sortBy,
              sortField: this.sortField,
            };
            this._cS.setLocalStorageItem(
              'status_data',
              JSON.stringify(local_data)
            );
          }
          this.isStatusLoaded = false;
        });
    } catch (error) {}
  }

  onSearch(event: any) {
    if (event.which != 9 && event.which != 18 && event.which != 27) {
      clearTimeout(this.timer);
      if (this.searchText.trim().length >= 3) {
        this.timer = setTimeout(() => {
          this.page = 1;
          this.lst_Status = [];
          if (this.statusList_Request) this.statusList_Request.unsubscribe();
          // this.getStatusList();
          if (this.currentStatus == 1) {
            this.getStatusList();
          } else {
            this.getIncompletedStatusList();
          }
        }, 1000);
      } else {
        if (this.searchText == '') {
          this.oldSearchText = '';
          this.page = 1;
          this.lst_Status = [];
          if (this.statusList_Request) this.statusList_Request.unsubscribe();
          // this.getStatusList();
          if (this.currentStatus == 1) {
            this.getStatusList();
          } else {
            this.getIncompletedStatusList();
          }
        }
      }
    }
  }

  // removeStock(p: any, data: any, i: number, pi: number,) {
  //   if (this.lst_Status[i].stocks.length > 1) {
  //     this._blS.DeleteAssignmentStock(data.id, p.id).subscribe(res => {
  //       if (res) {
  //         if (res.responseStatus == ResponseStatus.Success) {
  //           this._cS.displayMessage(ResponseMessageStatus.success, res.message);
  //           this.lst_Status[i].stocks.splice(pi, 1);
  //           this.lst_Status[i].stocks = [...this.lst_Status[i].stocks];
  //         } else {
  //           this._cS.displayMessage(ResponseMessageStatus.error, res.message);
  //         }
  //       }
  //     })
  //   }
  //   else
  //     this._cS.displayMessage(ResponseMessageStatus.info, 'At least one part should be needed in status.');
  // }
  removePartNumber(p: any, data: any, i: number, pi: number) {
    var statusIndex = this.lst_Status.findIndex((x: any) => x.id == data.id);
    if (statusIndex > -1 && this.lst_Status[statusIndex].stocks.length == 1) {
      this._cS.displayMessage(
        ResponseMessageStatus.info,
        'At least one part number of stock should be needed in status.'
      );
    } else if (statusIndex > -1) {
      this._blS
        .DeleteAssignmentPartNumber(p.assignmentId, p.stockId, p.partNumber)
        .subscribe((res) => {
          if (res) {
            if (res.responseStatus == ResponseStatus.Success && res.result) {
              this._cS.displayMessage(
                ResponseMessageStatus.success,
                res.message
              );
              this.lst_Status[i].stocks.splice(pi, 1);
              this.lst_Status[statusIndex].stocks = [
                ...this.lst_Status[statusIndex].stocks,
              ];

              // this.lst_Status[statusIndex].stocks[i].partNumbers.splice(pi, 1);
              // this.lst_Status[statusIndex].stocks[i].partNumbers = [

              if (
                this.lst_Status[statusIndex].stocks[i]?.partNumbers?.length == 0
              ) {
                this.lst_Status[statusIndex].stocks[i].splice(statusIndex, 1);
              }
            } else {
              this._cS.displayMessage(ResponseMessageStatus.error, res.message);
            }
          }
        });
    }
  }

  changeCalledStatus(data: any) {
    try {
      this._blS.UpdateCalledStatus(data.id, data.isCalled).subscribe((res) => {
        if (res) {
          if (res.responseStatus == ResponseStatus.Success && res.result) {
            data.isCalled = res.result.isCalled;
            this._cS.displayMessage(ResponseMessageStatus.success, res.message);
          } else {
            data.isCalled = !res.result.isCalled;
            this._cS.displayMessage(ResponseMessageStatus.error, res.message);
          }
        }
      });
    } catch (error) {}
  }

  sort(key: string) {
    if (key) {
      this.sortBy = this.sortBy == SortBy.Asc ? SortBy.Dsc : SortBy.Asc;
      this.sortField = key;
      this.page = 1;
      this.lst_Status = [];
      if (this.statusList_Request) this.statusList_Request.unsubscribe();
      if (this.currentStatus == 1) {
        this.getStatusList();
      } else {
        this.getIncompletedStatusList();
      }
      // this.getStatusList();
    }
  }

  showHistoryModal(data: any) {
    this.isAuditVisible = true;
    this.entityDetails = data;
  }

  // "Sync from AfterShip" modal. Rows without a tracking number have nothing to look up.
  afterShipOrder: any = null;
  showAfterShipSync(data: any) {
    if (data?.qB_TrackingNo) this.afterShipOrder = data;
  }

  hideAfterShipSync(event: any) {
    this.afterShipOrder = null;
    if (event?.synced) this.loadStatusData();
  }

  hideAuditModal(event: any) {
    this.isAuditVisible = !event.hide;
  }

  onScrollDown() {
    if (this.page != this.statusMaxPageSize) {
      this.page += 1;
      if (this.currentStatus == 1) {
        this.getStatusList();
      } else {
        this.getIncompletedStatusList();
      }
      // this.getStatusList();
    }
  }

  onAllCheckedAccountData(value: boolean): void {
    this.lst_Status.forEach((item: any) =>
      this.updateCheckedSetAccountData(item.id, value)
    );
    this.lst_Status.forEach((item: any) => (item.isChecked = value));
    this.refreshCheckedStatusAccountData();
  }

  updateCheckedSetAccountData(id: number, checked: boolean): void {
    if (checked) {
      this.setOfCheckedIdAccountData.add(id);
    } else {
      this.setOfCheckedIdAccountData.delete(id);
    }
  }
  onItemCheckedAccountData(id: number, checked: boolean): void {
    this.updateCheckedSetAccountData(id, checked);
    this.lst_Status.forEach((item: any) => {
      if (item.id === id) {
        item.isChecked = true;
        return;
      }
    });
    this.refreshCheckedStatusAccountData();
  }

  refreshCheckedStatusAccountData(): void {
    if (this.lst_Status && this.lst_Status.length > 0) {
      this.checkedAccountData = this.lst_Status.every((item: any) =>
        this.setOfCheckedIdAccountData.has(item.id)
      );
    }
    this.indeterminateAccountData =
      this.lst_Status.some((item: any) =>
        this.setOfCheckedIdAccountData.has(item.id)
      ) && !this.checkedAccountData;
  }

  showChangeShipDate() {
    this.isShowChangeShipDate = true;
  }

  changeShipDate() {
    var lst_ChangedShipDate: any = [];
    this.lst_Status.map((x: any) => {
      this.setOfCheckedIdAccountData.forEach((item: any) => {
        if (x.id == item) {
          lst_ChangedShipDate.push({
            transactionIDs: x.transactionID,
            oldShiipDate: x.qB_ShipDate,
            oldStatus: x.qB_BL_Status,
          });
        }
      });
    });
    var body = {
      shiipDateAndStatus:
        lst_ChangedShipDate && lst_ChangedShipDate.length > 0
          ? lst_ChangedShipDate
          : [],
      shippingDate: this.shipDate,
      status: this.bl_Status ? this.bl_Status : '',
    };
    this._blS.UpdateShippedDateAndStatus(body).subscribe((res) => {
      if (res) {
        if (res.responseStatus == ResponseStatus.Success) {
          // this.isStatusLoaded = true;
          // this.page = 1;
          // this.lst_Status = [];

          this._cS.displayMessage(
            ResponseMessageStatus.success,
            'QB ship date and status updated successfully, It will take some time.'
          );
          if (
            this.currentStatus == 2 &&
            !this.bl_Status.toLocaleLowerCase().includes('shipped')
          ) {
            lst_ChangedShipDate.forEach((element: any) => {
              if (element.transactionIDs) {
                this.lst_Status = this.lst_Status.filter(
                  (x: any) => x.transactionID !== element.transactionIDs
                );
              }
            });
          }
          this.isShowChangeShipDate = false;
          lst_ChangedShipDate.push({
            transactionIDs: lst_ChangedShipDate.transactionID,
            oldShiipDate: lst_ChangedShipDate.qB_ShipDate,
            oldStatus: lst_ChangedShipDate.qB_BL_Status,
          });
          this.lst_Status.map((x: any) => {
            this.setOfCheckedIdAccountData.forEach((item: any) => {
              if (x.id == item) {
                x.qB_ShipDate = this.shipDate;
                x.qB_BL_Status = this.bl_Status
                  ? this.bl_Status
                  : x.qB_BL_Status;
              }
            });
          });
          var data = res.result;
          if (data && data.length > 0) {
            data.forEach((x: any) => {
              this.lst_Status.push(x);
            });
          }

          this.lst_Status = [...this.lst_Status];
          this.setOfCheckedIdAccountData.clear();
          this.refreshCheckedStatusAccountData();
          this.handleCancel();
          this.shipDate = new Date();
          this.bl_Status = '';
          setTimeout(() => {
            this._cS.incompleteStatusCountObserver.next('call');
          }, 5000);

          //re fetch data
          this.page = 1;
          this.lst_Status = [];
          if (this.currentStatus == 1) {
            this.getStatusList();
          } else {
            this.getIncompletedStatusList();
          }
        } else {
          this._cS.displayMessage(ResponseMessageStatus.error, res.message);
        }
      }
    });
  }

  handleCancel() {
    this.isShowChangeShipDate = false;
  }

  onDateChange(result: any) {
    if (result.startDate == null) {
      let todayDate = new Date();
      todayDate.setHours(0, 0, 0);
      this.filterDate[0] =
        this._datepipe.transform(todayDate, 'yyyy-MM-dd') + 'T00:00:00Z';
      this.filterDate[1] =
        this._datepipe.transform(todayDate, 'yyyy-MM-dd') + 'T23:59:59Z';
    } else {
      this.filterDate[0] = result?.startDate?.utc().format();
      this.filterDate[1] = result?.endDate?.utc().format();
    }
    this.lst_Status = [];
    this.page = 1;
    if (this.currentStatus == 1) {
      this.getStatusList();
    } else {
      this.getIncompletedStatusList();
    }
    // this.getStatusList();
  }

  isAscPart: boolean = true;
  sortPart(isAsc: any, data: any) {
    this.isAscPart = isAsc;
    var ar = data.sort(function (a: any, b: any) {
      var nA = isAsc ? a.partNumber.toLowerCase() : b.partNumber.toLowerCase();
      var nB = isAsc ? b.partNumber.toLowerCase() : a.partNumber.toLowerCase();

      if (nA < nB) return -1;
      else if (nA > nB) return 1;
      return 0;
    });
    data = ar;
  }
  isExpandAll: boolean = true;
  expandAll() {
    var assignmentIds = this.lst_Status.map((a: any) => a.id);
    var body = [assignmentIds.join(',')];
    this._blS.ExpandAllPartnumber(body).subscribe((res) => {
      if (res) {
        if (
          res.responseStatus == ResponseStatus.Success &&
          res.result.records
        ) {
          this.isExpandAll = !this.isExpandAll;
          var data = res.result.records;
          this.lst_Status.map((x: any) => {
            x.expand = !this.isExpandAll ? true : false;
            x['stocks'] = [];
            data.forEach((ele: any) => {
              if (x.id == ele.assignmentId) {
                x['stocks']?.push(ele);
              }
            });
          });
        } else {
          this._cS.displayMessage(ResponseMessageStatus.error, res.message);
        }
      }
    });
  }
  //#endregion
  constructor(
    private _blS: BadeLoftService,
    public _cS: CommonService,
    private _router: Router,
    private _route: ActivatedRoute,
    private modal: NzModalService,
    private _datepipe: DatePipe,
    private cdref: ChangeDetectorRef
  ) {
    this.stockLocation = StockLocation;
  }

  ngOnInit(): void {
    this.selected = {
      start: this.ranges['Today'][0],
      end: this.ranges['Today'][1],
    };
    this.loadStatusData(false);
  }
  loadStatusData(isFromRefresh = true) {
    var preReservedData: any = null;
    this.lst_Status = [];
    this.page = 1;
    preReservedData = this._cS.getLocalStorageItem('status_data');
    // this._route.queryParams.subscribe((params) => {
    //   if (params) {
    //     var filterStatus = params['filterstatus'];
    //     if (filterStatus == 2) {
    //       this.currentStatus = 2;
    //     }
    //   }
    // });
    this._cS.incompleteStatusRecords.subscribe((res: any) => {
      if (res) {
        this.currentStatus = 2;
        if (this.incompleteStatusList_Request) {
          this.incompleteStatusList_Request.unsubscribe();
        }
        this.page = 1;
        this.lst_Status = [];
        this.getIncompletedStatusList();
      } else {
        // this.page = 1;
        // this.lst_Status = [];
        // if (this.statusList_Request) this.statusList_Request.unsubscribe();
        // this.getStatusList();
        // this.currentStatus = 1;
      }
    });
    if (preReservedData) {
      preReservedData = JSON.parse(preReservedData);
      // this.page = preReservedData.page;
      // this.pageSize = preReservedData.pageSize;
      this.searchText = preReservedData.searchText;
      this.sortBy = preReservedData.sortBy;
      this.sortField = preReservedData.sortField;
    }
    setTimeout(() => {
      if (isFromRefresh) {
        if (this.currentStatus == 1) {
          this.getStatusList();
        } else {
          if (this.incompleteStatusList_Request)
            this.incompleteStatusList_Request.unsubscribe();
          this.getIncompletedStatusList();
        }
      }
    }, 100);
    this._cS.incompleteStatusCountObserver.next('call');
  }

  showAssignmentEdit(assignment: any, stock: any) {
    // this._router.navigate(['/bade-loft/assignment'], {
    //   queryParams: { invoiceNumber: invoice },
    // });
    this.isAssignmentVisible = true;
    this.editAssignmentDetail = assignment;
    this.editAssignmentDetail['assigmentDetails'] = true;
    this.stockAssignmentDetail = stock;
  }

  hideModal(event: any) {
    if (event.hide) {
      this.isAssignmentVisible = !event.hide;
    }
  }

  //check filter status
  checkStatusToGetRecords() {
    if (this.currentStatus == 1) {
      this.lst_Status = [];
      this.page = 1;
      this.getStatusList();
      this._cS.incompleteStatusRecords.next(null);
    } else {
      this.lst_Status = [];
      this.page = 1;
      this.getIncompletedStatusList();
    }
  }

  ngOnDestroy(): void {
    // var local_data = { page: this.page, pageSize: this.pageSize, searchText: this.searchText, sortBy: this.sortBy, sortField: this.sortField };
    // this._cS.setLocalStorageItem('status_data', JSON.stringify(local_data));
  }
  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }
}
